// ------------------------------------------------------------------
// Máscara de telefone brasileiro — deliberadamente conservadora.
//
// A base é heterogênea. Levantamento em 02/08/2026 no dump de produção:
//
//   (21) 99971-9078            celular com DDD .......... 11 dígitos
//   (21) 3444-9681             fixo com DDD ............. 10 dígitos
//   22363301                   fixo LOCAL, sem DDD ....... 8 dígitos
//   22582035 22868002          DOIS telefones no campo .. 16 dígitos
//   33261640 2588 5810 ...     vários no mesmo campo .... 24+ dígitos
//
// Por isso só formatamos o que é inequivocamente um telefone brasileiro
// com DDD (10 ou 11 dígitos). Qualquer outro conteúdo é devolvido
// intacto: formatar "22363301" inventaria o DDD 22, e cortar em 11
// dígitos destruiria o segundo número de quem tem dois no mesmo campo —
// como o parse grava o que é exibido, o estrago iria para o banco.
// ------------------------------------------------------------------

const somenteDigitos = (valor: any) =>
  (valor ?? "").toString().replace(/\D/g, "");

export const formatPhone = (valor: any): string => {
  const original = (valor ?? "").toString();
  const d = somenteDigitos(original);

  // Os DDDs brasileiros vão de 11 a 99. Fora disso não é DDD — o caso mais
  // comum na base é a convenção antiga de prefixar com zero ("031 35472420",
  // "(011) 3742-0318"). Formatar isso leria o "01" como DDD e produziria
  // "(01) 13742-0318": nenhum dígito se perde, mas o número passa a parecer
  // errado. Melhor deixar como está.
  const ddd = Number(d.slice(0, 2));
  const dddValido = ddd >= 11 && ddd <= 99;

  if (dddValido) {
    // Fixo com DDD: (21) 3444-9681
    if (d.length === 10) {
      return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
    }
    // Celular com DDD: (21) 99971-9078
    if (d.length === 11) {
      return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
    }
  }

  // Sem DDD, DDD inválido, com ramal, mais de um número, internacional:
  // devolve exatamente como está.
  return original;
};

/**
 * Campo esvaziado vira `null` — a API converte nulo em string vazia para
 * os campos de telefone (`resetAbleStringFields`), então apagar funciona.
 */
export const parsePhone = (valor: any) => {
  const formatado = formatPhone(valor);
  return formatado === "" ? null : formatado;
};

/** Props prontas para `<TextInput {...phoneProps} />`. */
export const phoneProps = {
  format: formatPhone,
  parse: parsePhone,
};
